import * as React from "react";

function SvgCircularLoader(props) {
  return (
    <svg
      style={{
        margin: "auto",
      }}
      width={200}
      height={200}
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      display="block"
      {...props}
    >
      <path
        d="M10.23 46.595a40 40 0 0079.71 6.818 40 42 4.89 01-79.71-6.818"
        fill={props.color}
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          dur="1s"
          repeatCount="indefinite"
          keyTimes="0;1"
          values="0 50 51;360 50 51"
        />
      </path>
    </svg>
  );
}

export default SvgCircularLoader;
